module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-72x72-b0a67b1dab9048e2d99259b0c3a5773c.png";